import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-766ba05f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = { class: "detail-order-statusbox" }
const _hoisted_3 = { class: "detail-order-status" }
const _hoisted_4 = { class: "detail-order-desc" }
const _hoisted_5 = { class: "detail-net-message" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "基础信息", -1))
const _hoisted_7 = { class: "dingze-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "维修单类型", -1))
const _hoisted_9 = { class: "dingze-item-value" }
const _hoisted_10 = { class: "dingze-item last-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "维修网点", -1))
const _hoisted_12 = { class: "dingze-item-value" }
const _hoisted_13 = {
  key: 0,
  class: "detail-net-message"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "维修配件", -1))
const _hoisted_15 = { class: "detail-repair-desc" }
const _hoisted_16 = { class: "repair-desc-first" }
const _hoisted_17 = { class: "materil-name" }
const _hoisted_18 = { class: "materil-num" }
const _hoisted_19 = { class: "repair-desc-second" }
const _hoisted_20 = { class: "repair-desc-second" }
const _hoisted_21 = {
  key: 1,
  class: "appeal-box error-log"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检测情况", -1))
const _hoisted_23 = {
  key: 2,
  class: "order-pay-box"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-pay-box-title" }, "账单费用", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-pay-box-sectitle" }, "非最终费用，最终支付以实际为准", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-pay-box-online" }, "线上支付", -1))
const _hoisted_27 = { class: "order-pay-metarial" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "配件费用", -1))
const _hoisted_29 = { class: "order-pay-metarial last-pay-metarial" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "维修工时费用", -1))
const _hoisted_31 = {
  key: 0,
  class: "order-pay-box-quanbao"
}
const _hoisted_32 = { class: "order-pay-quanbao-item" }
const _hoisted_33 = { style: {"color":"#f85359"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-pay-quanbao-desc" }, "根据政策抵扣维修物料费和工时费", -1))
const _hoisted_35 = { class: "remain-pay-box" }
const _hoisted_36 = { style: {"color":"#00b359","font-weight":"bold"} }
const _hoisted_37 = {
  key: 0,
  class: "remaining-amount"
}
const _hoisted_38 = {
  key: 1,
  class: "remaining-amount"
}
const _hoisted_39 = {
  key: 0,
  class: "confirm-fixed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", {
    class: "appeal-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_ctx.pagePaddingTop)}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, {
        title: "维修单",
        isReturnLeftEvent: true,
        onLeftClick: _ctx.handleClikBack
      }, null, 8, ["onLeftClick"])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.repairBaseMessage.repair_status_text), 1),
          _createElementVNode("div", _hoisted_4, "维修单号：" + _toDisplayString(_ctx.repairBaseMessage.repair_sn), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.repairBaseMessage.service_type_text), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.repairBaseMessage.repair_warehouse_name), 1)
          ])
        ]),
        (_ctx.repairBaseMessage.repair_status >= 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repairBaseMessage.mateList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass({
            'detail-repair-device': true,
            'last-repair-item': index == _ctx.repairBaseMessage.mateList.length - 1,
          }),
                  key: index
                }, [
                  _createElementVNode("div", {
                    class: "detail-repair-image",
                    style: _normalizeStyle(item.image ? { 'background-image': `url(${item.image})` } : {})
                  }, null, 4),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(item.material_name), 1),
                      _createElementVNode("span", _hoisted_18, "X" + _toDisplayString(item.num), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, " 配件费用￥" + _toDisplayString(item.discount_price.toFixed(2)) + "(原价￥" + _toDisplayString(item.raw_price.toFixed(2)) + "，抵扣￥" + _toDisplayString(item.discount_amount.toFixed(2)) + ") ", 1),
                    _createElementVNode("div", _hoisted_20, " 工时费￥" + _toDisplayString(item.discount_hourly_price.toFixed(2)) + "(原价￥" + _toDisplayString(item.raw_hourly_price.toFixed(2)) + "，抵扣￥" + _toDisplayString(item.hourly_discount_amount.toFixed(2)) + ") ", 1)
                  ])
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.repairBaseMessage.repair_status >= 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", {
                class: "appeal-box-title appeal-box-felxtitle",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCheckDetail && _ctx.handleCheckDetail(...args)))
              }, [
                _hoisted_22,
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  size: "16",
                  color: "rgba(0,0,0,0.44)"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.repairBaseMessage.repair_status >= 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", null, "￥" + _toDisplayString(_ctx.repairBaseMessage.mate_amount.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("span", null, "￥" + _toDisplayString(_ctx.repairBaseMessage.hourly_amount.toFixed(2)), 1)
              ]),
              (_ctx.repairBaseMessage.service_type != 'NO')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.repairBaseMessage.service_type_text) + "费用抵扣", 1),
                      _createElementVNode("span", _hoisted_33, "-￥" + _toDisplayString(_ctx.repairBaseMessage.discount_amount.toFixed(2)), 1)
                    ]),
                    _hoisted_34
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", null, _toDisplayString(_ctx.repairBaseMessage.pay_status_text) + "：", 1),
                _createElementVNode("span", _hoisted_36, "￥" + _toDisplayString(_ctx.repairBaseMessage.pay_amount.toFixed(2)), 1),
                (
              ['X_CARE_UPGRADE', 'X_CARE_2021_V1', 'X_CARE_2021_V2'].indexOf(
                'repairBaseMessage.service_type'
              ) >= 0 && false
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 支付后剩余全保额度 ￥" + _toDisplayString(_ctx.repairBaseMessage.current_amount.toFixed(2)), 1))
                  : _createCommentVNode("", true),
                (_ctx.repairBaseMessage.service_type == 'X_CARE_RENEW_2021')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 支付后剩余延保额度 ￥" + _toDisplayString(_ctx.repairBaseMessage.current_amount.toFixed(2)), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    (_ctx.btnStatus.showRepairbtn || _ctx.btnStatus.showPaybtn || _ctx.btnStatus.showApplyInovice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          (_ctx.btnStatus.showRepairbtn)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "repair-confirm-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
              }, " 确认维修 "))
            : _createCommentVNode("", true),
          (_ctx.btnStatus.showPaybtn)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "repair-confirm-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlePayRepairOrder && _ctx.handlePayRepairOrder(...args)))
              }, " 确认支付 "))
            : _createCommentVNode("", true),
          (_ctx.btnStatus.showApplyInovice)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "repair-confirm-btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleApplyInvoice && _ctx.handleApplyInvoice(...args)))
              }, " 申请发票 "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}